export const NONE_LABEL = $localize`default.label.none`;
